import "./not-found.scss";

const NotFound = () => {
  return (
    <section className="not-found">
      <div className="container">
        <h2>Page not found!</h2>
      </div>
    </section>
  );
};

export default NotFound;
